import { createApp } from 'vue';
import MortgageMarketReport from '@/js/vue-components/pages/analytics/mortgage-market-report/MortgageMarketReport';

createApp({
    components: {
        MortgageMarketReport
    }
}).mount('#app');
